import styled from 'styled-components'

import theme from 'theme_'

const { spacing } = theme

export const BlurredBlock = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0;
  color: ${theme.colors.otterWarmBlack};
  border-radius: ${theme.spacing.xs};
  background-color: ${theme.overlay.cardColor2};
  backdrop-filter: ${theme.overlay.SBlur};
  animation: ${theme.animations.fadeIn} 0.2s ease-out;
`

export const WhiteBlock = styled.div<{ bigPadding?: boolean }>`
  display: flex;
  flex-direction: column;
  padding: ${spacing.base} ${spacing.md} ${spacing.md};
  border-radius: ${theme.spacing.xs};
  background-color: ${theme.colors.white};
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.01);
  animation: ${theme.animations.fadeIn} 0.2s ease-out;

  ${(p) =>
    p.bigPadding &&
    `
    display: block;
    padding: ${spacing.xxl};
    color: ${theme.colors.darkeyGrey};
    text-align: center;
  `}
`

export const GreyMiniBlock = styled(WhiteBlock)`
  padding: ${spacing.xs} ${spacing.base} ${spacing.base};
  background-color: ${theme.colors.lighterGrey};
`
